import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=4434d374&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=4434d374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434d374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4434d374')) {
      api.createRecord('4434d374', component.options)
    } else {
      api.reload('4434d374', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=4434d374&scoped=true&", function () {
      api.rerender('4434d374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/module/orderInfo.vue"
export default component.exports